import {
  Box,
  IconButton,
  InputAdornment,
  InputBaseComponentProps,
  InputLabel,
  SxProps,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface TextFieldUpdaterProps {
  label: string;
  value: string | undefined;
  setValue?: Function;
  disabled?: boolean;
  onEdit?: Function;
}

const tfLabelProps: SxProps = {
  fontFamily: "Manrope",
  color: "#6f7d95",
  fontSize: "1rem !important",
  fontWeight: 600,
};

const tfMainStyle: SxProps = {
  backgroundColor: "#f4f6f9 !important",
  borderRadius: "5px !important",
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "0px",
  },
};

const tfInputStyle: SxProps = {
  fontFamily: "Manrope",
  backgroundColor: "#f4f6f9",
  color: "#6f7d95",
  fontSize: "1rem !important",
  fontWeight: 500,
};

const TextFieldUpdater: React.FC<TextFieldUpdaterProps> = ({
  label,
  value,
  setValue,
  disabled,
  onEdit,
}) => {
  return (
    <Box aria-label="TextFieldUpdater-Container" sx={{ width: "100%" }}>
      <InputLabel sx={tfLabelProps}>{label}</InputLabel>
      <TextField
        disabled={disabled}
        value={value}
        onChange={(e) => {
          setValue && setValue(e.target.value);
        }}
        InputProps={{
          disableUnderline: true,
          sx: tfInputStyle,
          endAdornment: onEdit && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onEdit()}>
                <EditIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={tfMainStyle}
        fullWidth
      />
    </Box>
  );
};

export default TextFieldUpdater;
